import { render } from "./ConfirmationCommandePermis.vue?vue&type=template&id=24730640&scoped=true&ts=true"
import script from "./ConfirmationCommandePermis.vue?vue&type=script&lang=ts"
export * from "./ConfirmationCommandePermis.vue?vue&type=script&lang=ts"

import "./ConfirmationCommandePermis.vue?vue&type=style&index=0&id=24730640&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24730640"]])

export default __exports__